export interface BidPackDestination {
  Id: number;
  DestinationGsdb: string;
  DestinationTypeId: number;
}

export const defaultBidPackDestination: BidPackDestination = {
  Id: 0,
  DestinationGsdb: "",
  DestinationTypeId: 0,
};
